<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { LinkComponentTextProps } from './types';

  type $$Props = LinkComponentTextProps;
  export let nofollow: $$Props['nofollow'] = undefined;
  export let target: $$Props['target'] = undefined;
  export let text: $$Props['text'];
  export let url: $$Props['url'];
  export let body: $$Props['body'] = undefined;
  export let doArrowWrap: $$Props['doArrowWrap'] = undefined;
  export let textExceptLastWord: $$Props['textExceptLastWord'] = undefined;
  export let textLastWord: $$Props['textLastWord'] = undefined;
  export let balanceText: $$Props['balanceText'] = undefined;
  export let type: $$Props['type'];
  // currently only used to support no arrow links on StickyBannerSection
  export let noArrow: $$Props['noArrow'] = undefined;
  export let modal: $$Props['modal'] = undefined;

  export let variant: $$Props['variant'] = 'text';

  const noHoverTypes = ['text - plain', 'text - reduced-motion'];

  const dispatch = createEventDispatcher();

  function handleOnClick(event: Event) {
    if (modal) {
      event.preventDefault();
      dispatch('open-modal');
    }
  }
</script>

<a
  class={`LinkComponent--${variant}`}
  href={url}
  {target}
  rel={nofollow}
  class:balance-text={balanceText}
  class:arrow={!noArrow}
  class:full-motion={!noHoverTypes.includes(type)}
  on:click={handleOnClick}
>
  {#if doArrowWrap}
    {#if textExceptLastWord}
      {textExceptLastWord}
    {/if}
    <span class="no-wrap">{textLastWord}</span>
  {:else}
    <span>{text}</span>
  {/if}
</a>
{#if body}
  <div class="body">
    <!-- eslint-disable-next-line svelte/no-at-html-tags - body is sanitized using richTextRendererHelper -->
    {@html body}
  </div>
{/if}

<style lang="scss">
  .LinkComponent--text {
    position: relative;
  }

  .LinkComponent--text-alt {
    position: relative;
    display: inline-block;
    color: var(--color-link-secondary);
    text-decoration: underline;
    text-underline-offset: 0.3em;

    // per design, no color difference between hover and active
    &:hover,
    &:active {
      color: var(--color-link-secondary-hover);
    }
  }

  .arrow span {
    &::after {
      content: '→';
      pointer-events: none;
      display: inline-block;
      margin-left: 0.25em;
      line-height: initial;
      transition: transform var(--duration-quick) var(--easing-sharp);
    }

    &.no-wrap {
      white-space: nowrap;
    }
  }

  .full-motion:hover {
    @keyframes slide-forward {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(35%);
      }
    }

    span {
      &::after {
        animation-name: slide-forward;
        animation-duration: var(--duration-complex);
        animation-timing-function: var(--easing-decelerate);
        animation-iteration-count: 2;
        animation-direction: alternate;
      }
    }
  }

  .body :global(p) {
    margin-top: 0;
    margin-bottom: 0;
  }
</style>
